import React from 'react'
import { StyledIcon } from '../StyledIcon'

const style = {
  fill: '#ff9800',
  stroke: '#ff9800',
}

const FullStarIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 426.667 426.667"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <polygon
      points="213.333,10.441 279.249,144.017 426.667,165.436 320,269.41 345.173,416.226 213.333,346.91
81.485,416.226 106.667,269.41 0,165.436 147.409,144.017 "
      style={style}
    />
  </StyledIcon>
)

export default FullStarIcon
